import { useDispatch } from "react-redux";
import JenisMobilMain from "../../../features/masters/jenis-mobil/components/jenis-mobil-main";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import { useEffect } from "react";

const title = "Master Jenis Mobil";

const JenisMobilMasterPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <JenisMobilMain />;
};

export default JenisMobilMasterPage;
